import * as api from "api/rolePermissionApi";
import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource";

const QUERY_KEYS = {
  MODULE: "modules",
  PERMISSION: "permissions",
  ROLE: "roles",
  USER_ROLE: "userRoles",
}

// -------------------- MODULES --------------------
export const useModules = (params, enabled) =>
  usePaginatedResource(QUERY_KEYS.MODULE, api.getModules, params, enabled)
export const useModule = identifier =>
  useResourceItem(QUERY_KEYS.MODULE, api.getModule, identifier)

// -------------------- PERMISSIONS --------------------
export const usePermissions = (params, enabled) =>
  usePaginatedResource(
    QUERY_KEYS.PERMISSION,
    api.getPermissions,
    params,
    enabled
  )
export const usePermission = identifier =>
  useResourceItem(QUERY_KEYS.PERMISSION, api.getPermission, identifier)

// -------------------- ROLES --------------------
export const useRoles = (params, enabled) =>
  usePaginatedResource(QUERY_KEYS.ROLE, api.getRoles, params, enabled)
export const useRole = identifier => useResourceItem(QUERY_KEYS.ROLE, api.getRole, identifier)
export const useCreateRole = () =>
  useCreateResource(api.createRole, QUERY_KEYS.ROLE)
export const useEditRole = () => useEditResource(api.editRole, QUERY_KEYS.ROLE)
export const useDeleteRole = () =>
  useDeleteResource(api.deleteRole, QUERY_KEYS.ROLE)

// -------------------- USER ROLES --------------------
export const useUserRoles = (userId, params, enabled) =>
  usePaginatedResource(
    [QUERY_KEYS.USER_ROLE, userId],
    () => api.getUserRoles(userId, params),
    params,
    !!userId && enabled
  )

// -------------------- FETCH ROLE PERMISSIONS --------------------
export const useRolePermissions = (roleId, params = {}, enabled = true) => {
  return usePaginatedResource(["rolePermissions", roleId], enabled)
}

// -------------------- ASSIGN PERMISSIONS --------------------
export const useAssignPermissionsToRole = roleId => {
  return useCreateResource(
    permissionIds => api.assignPermissionsToRole(roleId, permissionIds),
    ["rolePermissions", roleId]
  )
}
